import { useClientContext } from "@hooks/index";
import { useMemo } from "react";
import {
  createJustification,
  getJustificationHistory,
  getLastJustification,
} from "./index";

export const useJustification = () => {
  const customFetch = useClientContext();

  return useMemo(
    () => ({
      getJustificationHistory: getJustificationHistory(customFetch),
      createJustification: createJustification(customFetch),
      getLastJustification: getLastJustification(customFetch),
    }),
    [customFetch]
  );
};
